export var CouponButtonPosition;
(function (CouponButtonPosition) {
    CouponButtonPosition[CouponButtonPosition["Fixed"] = 0] = "Fixed";
    CouponButtonPosition[CouponButtonPosition["Static"] = 1] = "Static";
})(CouponButtonPosition || (CouponButtonPosition = {}));
//# sourceMappingURL=CouponButtonPosition.js.map